import React, { useState , useEffect} from "react";
import Select from "react-select";
import { RefreshCw, Clock } from "lucide-react";
import redirectURL from "../redirectURL"
import "../../assets/css/inventorymanagement.css"
import SweetAlert from "react-bootstrap-sweetalert";

const ReplenishmentSettings = () => {
  const [formData, setFormData] = useState({
    reorderTriggerLogic: null,
    allocationLogic: null,
    runFrequency: null,
    optimizationGoal: null,
    riskTolerance: null,
    emergencyReplenishment: false,
    preferSingleSource: false,
    replenishmentHorizon: "7",
    bufferDays: "3",
    splitThreshold: "500",
    maxSources: "3",
  });

  // Dummy options
  const reorderOptions = [
    { value: "daily_check", label: "Daily Check" },
    { value: "stock_threshold", label: "Stock Threshold" },
  ];

  const allocationOptions = [
    { value: "cost_based", label: "Cost Based" },
    { value: "priority_based", label: "Priority Based" },
  ];

  const runFrequencyOptions = [
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
  ];

  const goalOptions = [
    { value: "min_cost", label: "Minimize Cost" },
    { value: "max_service", label: "Maximize Service Level" },
  ];

  const toleranceOptions = [
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" },
  ];

  // Handlers
  const handleSelectChange = (selectedOption, key) => {
    setFormData({ ...formData, [key]: selectedOption });
    console.log(`${key} changed to`, selectedOption?.value);
  };

  const handleInputChange = (e, key) => {
    setFormData({ ...formData, [key]: e.target.value });
    console.log(`${key} updated to`, e.target.value);
  };

  const toggleSwitch = (key) => {
    setFormData({ ...formData, [key]: !formData[key] });
    console.log(`${key} toggled to`, !formData[key]);
  };

  const dropdownStyle = {
    width: "100%",
    paddingTop: 5,
    paddingBottom: 5,
    marginBottom: 10,
  };

  const sectionStyle = {
    flex: 1,
    padding: 20,
    border: "1px solid #eee",
    borderRadius: 10,
    marginBottom: 20,
    background: "#fff",
  };

  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n")

  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  const [orderConformationSweetAlert,setOderConformationSweetAlert] = useState({
    show:false,

  })

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    if (basicTitle !== "Please fill all the fields"){
            localStorage.setItem('activeTab', "replenishment");
    window.location.reload();
    }

   }

  
  useEffect(() => {
    const fetchData = async () => {
          setLoadshow("show-m");
          setOverlayBlock("show-m");
      try {
        const response = await redirectURL.post("inventory/fetchConfigurations", {});
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                const data = response.data.data[0].replenishment_logic ? JSON.parse(response.data.data[0].replenishment_logic) : {};   
                if (Object.keys(data).length > 0) { 
                console.log(data.formData) // Checking if data is not empty
                  setFormData(data.formData)
              }
            }
              setLoadshow("show-n");
              setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicTitle("Something Went Wrong");
          setBasicType("warning");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicTitle("Something Went Wrong");
        setBasicType("warning");
      }
    };

    fetchData();
  }, []); // Empty dependency array to run only once when the component mounts


  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
  };

  const handleProcessConformation = async() => {
      setOderConformationSweetAlert({show:false})

        if (formData.reorderTriggerLogic === null ||formData.allocationLogic === null ){
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicTitle("Please fill all the fields");
          setBasicType("warning");
          return
          }


      setLoadshow("show-m")
      setOverlayBlock("show-m")
      const data = JSON.stringify({formData});
      const params = {
                    screenName :"replenishment_logic",
                    data : data
          }
      const response = await redirectURL.post("inventory/saveConfigurations", params)
      if (response.status === 200){
              setLoadshow("show-n");
              setOverlayBlock("show-n");
              setShow(true);
              setBasicTitle("Configurations Successfully Saved");
              setBasicType("success");
      }
      else{
              setLoadshow("show-n");
              setOverlayBlock("show-n");
              setShow(true);
              setBasicTitle("Something Went Wrong");
              setBasicType("warning");
      }
  }
  
  const handleProcessCancel = () => {
      setOderConformationSweetAlert({show:false})
  }
  const saveConfigurations = async() => {
    setOderConformationSweetAlert({show:true})
    }

  return (
    <div style={{ padding: 20, fontFamily: "sans-serif" }}>
      <div style={{ zIndex: "9999999" }}>
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
                style={{ fontSize: "9px" }}
            >
            </SweetAlert>
      </div>
      <div style={{ zIndex: "9999999" }}>
          
          <SweetAlert
            show={orderConformationSweetAlert.show}
            title="Are you sure?"
            type="info"
            showCancel
            confirmBtnText="Yes"
            cancelBtnText="No"
            confirmBtnStyle={{
              backgroundColor: "#007bff",
              color: "#fff",
              fontWeight: "bold",
              border: "none",
              borderRadius: "4px",
              padding: "6px 16px",
              fontSize: "14px",
            }}
            cancelBtnStyle={{
              backgroundColor: "#ea5e5e",
              color: "#fff",
              fontWeight: "bold",
              border: "none",
              borderRadius: "4px",
              padding: "6px 16px",
              fontSize: "14px",
            }}
            onConfirm={handleProcessConformation}
            onCancel={handleProcessCancel}
            focusCancelBtn
          >
                Do you want to save Configurations?
          </SweetAlert>
      </div>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
        <RefreshCw size={24} color="#f97316" style={{ marginRight: 10 }} />
        <div>
          <h2 style={{ margin: 0 }}>Replenishment Logic Settings</h2>
          <p style={{ margin: 0, color: "#6b7280" }}>
            Configure automated replenishment triggers and allocation logic
          </p>
        </div>
      </div>

      {/* Triggers & Allocation */}
      <div style={{ display: "flex", gap: 20 }}>
        {/* Reorder Triggers */}
        <div style={sectionStyle}>
          <h3>Reorder Triggers</h3>
          <p style={{ color: "#6c757d" }}>
            Configure when replenishment orders are triggered
          </p>
          <label>Reorder Trigger Logic</label>
          <div style={dropdownStyle}>
            <Select
              options={reorderOptions}
              value={formData.reorderTriggerLogic}
              onChange={(option) => handleSelectChange(option, "reorderTriggerLogic")}
            />
          </div>

          <label>Replenishment Horizon (days)</label>
          <input
            type="number"
            value={formData.replenishmentHorizon}
            onChange={(e) => handleInputChange(e, "replenishmentHorizon")}
            style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc", marginBottom: 10 }}
          />

          <label>Buffer Days Before Stockout</label>
          <input
            type="number"
            value={formData.bufferDays}
            onChange={(e) => handleInputChange(e, "bufferDays")}
            style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc", marginBottom: 10 }}
          />

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
            <label>Enable Emergency Replenishment</label>
            <input
              type="checkbox"
              checked={formData.emergencyReplenishment}
              onChange={() => toggleSwitch("emergencyReplenishment")}
            />
          </div>
        </div>

        {/* Multi-Source Allocation */}
        <div style={sectionStyle}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Clock size={20} style={{ marginRight: 8 }} />
            <h3 style={{ margin: 0 }}>Multi-Source Allocation</h3>
          </div>
          <p style={{ color: "#6c757d" }}>
            Configure how orders are allocated across multiple sources
          </p>

          <label>Multi-source Allocation Logic</label>
          <div style={dropdownStyle}>
            <Select
              options={allocationOptions}
              value={formData.allocationLogic}
              onChange={(option) => handleSelectChange(option, "allocationLogic")}
            />
          </div>

          <label>Split Order Threshold</label>
          <input
            type="number"
            value={formData.splitThreshold}
            onChange={(e) => handleInputChange(e, "splitThreshold")}
            style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc", marginBottom: 10 }}
          />

          <label>Max Sources per Order</label>
          <input
            type="number"
            value={formData.maxSources}
            onChange={(e) => handleInputChange(e, "maxSources")}
            style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc", marginBottom: 10 }}
          />

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
            <label>Prefer Single Source</label>
            <input
              type="checkbox"
              checked={formData.preferSingleSource}
              onChange={() => toggleSwitch("preferSingleSource")}
            />
          </div>
        </div>
      </div>
      <div className="col-sm-12" style={{textAlign: "right", display : "flex", justifyContent: "flex-end"}}>
            <button 
                onClick={() => { saveConfigurations() }}
                style={{
                  
                  padding: "10px 20px",
                  backgroundColor: "#991548",
                  color: "white",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 14,
                  cursor: "pointer",
                }}
                  >
                    Save All Configurations
            </button>
      </div>
      {/* Advanced Settings */}
      {/* <div style={sectionStyle}>
        <h3>Advanced Settings</h3>
        <p style={{ color: "#6c757d" }}>Additional replenishment configuration options</p>
        <div style={{ display: "flex", gap: 20 }}>
          <div style={{ flex: 1 }}>
            <label>Planning Run Frequency</label>
            <Select
              options={runFrequencyOptions}
              value={formData.runFrequency}
              onChange={(option) => handleSelectChange(option, "runFrequency")}
              styles={{ container: () => dropdownStyle }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>Optimization Goal</label>
            <Select
              options={goalOptions}
              value={formData.optimizationGoal}
              onChange={(option) => handleSelectChange(option, "optimizationGoal")}
              styles={{ container: () => dropdownStyle }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>Risk Tolerance Level</label>
            <Select
              options={toleranceOptions}
              value={formData.riskTolerance}
              onChange={(option) => handleSelectChange(option, "riskTolerance")}
              styles={{ container: () => dropdownStyle }}
            />
          </div>
        </div>
      </div> */}

      
      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
        <div className={`overlay-block ${overlayBlock}`}></div>
        <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </div>
  );
};

export default ReplenishmentSettings;
